import { clearApiCache } from './ApiData.js';

// Designs saved with the Save icon, newest first: a small index of `?layout=` blobs, each capture under its own key.
export const HISTORY_KEY = 'feydom_design_history';
export const THUMBNAIL_PREFIX = 'feydom_design_thumb:';
export const HISTORY_LIMIT = 30;

export function readHistory() {
  try {
    const parsed = JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]');
    return Array.isArray(parsed) ? parsed.filter(e => e && typeof e.id === 'string' && typeof e.layout === 'string') : [];
  } catch {
    return [];
  }
}

export function readThumbnail(id) {
  try {
    return localStorage.getItem(THUMBNAIL_PREFIX + id);
  } catch {
    return null;
  }
}

function dropThumbnail(id) {
  try { localStorage.removeItem(THUMBNAIL_PREFIX + id); } catch { /* storage unavailable */ }
}

// A full quota frees the disposable API cache first, then the oldest designs, until the write fits.
function commit(entries, thumbnail = null) {
  let list = entries.slice(0, HISTORY_LIMIT);
  entries.slice(HISTORY_LIMIT).forEach(e => dropThumbnail(e.id));
  let cacheCleared = false;
  for (;;) {
    try {
      if (thumbnail) localStorage.setItem(THUMBNAIL_PREFIX + thumbnail.id, thumbnail.data);
      if (list.length) localStorage.setItem(HISTORY_KEY, JSON.stringify(list));
      else localStorage.removeItem(HISTORY_KEY);
      return list;
    } catch (error) {
      const full = error?.name === 'QuotaExceededError';
      if (full && !cacheCleared) {
        clearApiCache();
        cacheCleared = true;
      } else if (full && list.length > 1) {
        dropThumbnail(list.at(-1).id);
        list = list.slice(0, -1);
      } else {
        console.warn('[history] save failed:', error);
        return null;
      }
    }
  }
}

/** The saved entry, or null when storage refused it; re-saving the newest layout only refreshes it. */
export function saveToHistory({ layout, name = '', thumbnail = null }, now = Date.now()) {
  const entries = readHistory();
  const latest = entries[0]?.layout === layout ? entries.shift() : null;
  const entry = latest
    ? { ...latest, savedAt: now }
    : { id: `${now.toString(36)}-${Math.random().toString(36).slice(2, 7)}`, savedAt: now, name, layout };
  return commit([entry, ...entries], thumbnail && { id: entry.id, data: thumbnail }) ? entry : null;
}

export function removeFromHistory(id) {
  const entries = readHistory();
  const next = entries.filter(e => e.id !== id);
  if (next.length === entries.length) return false;
  dropThumbnail(id);
  return !!commit(next);
}
